export const SplitURL = (url) => {
  return url.split('/');
}